import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { EmployerLayout } from "@/components/employer/portal/EmployerLayout";
import { apiFetch, formatApiError, inputClass, Kicker, Label, PrimaryButton } from "@/components/employer/portal/shared";

export default function EmployerSettings() {
    const [form, setForm] = useState({ current_password: "", new_password: "" });
    const [busy, setBusy] = useState(false);
    const [changed, setChanged] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (busy) return;
        setBusy(true);
        setError("");
        setChanged(false);
        const res = await apiFetch("/employer/change-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(form),
        });
        if (res.ok) {
            setChanged(true);
            setForm({ current_password: "", new_password: "" });
        } else {
            const body = await res.json().catch(() => ({}));
            setError(formatApiError(body.detail, "Password could not be changed."));
        }
        setBusy(false);
    };

    return (
        <EmployerLayout title="Settings" subtitle="Manage your employer account security and portal preferences.">
            <div className="grid gap-8 lg:grid-cols-2" data-testid="employer-settings-page">
                <section className="border border-ink/10 bg-ivory p-7">
                    <Kicker>Change password</Kicker>
                    <form data-testid="employer-password-form" onSubmit={submit} className="mt-6 space-y-5">
                        <div><Label>Current password</Label><input data-testid="employer-current-password" type="password" required autoComplete="current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={inputClass} /></div>
                        <div><Label>New password</Label><input data-testid="employer-new-password" type="password" required minLength={8} autoComplete="new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inputClass} /></div>
                        {error && <p data-testid="employer-password-error" className="border-l-2 border-champagne pl-4 text-sm text-ink/70">{error}</p>}
                        <div className="flex items-center gap-4">
                            <PrimaryButton data-testid="employer-password-save" busy={busy} type="submit">Update Password</PrimaryButton>
                            {changed && <span data-testid="employer-password-changed" className="inline-flex items-center gap-1.5 text-sm text-forest"><CheckCircle2 size={15} /> Updated</span>}
                        </div>
                    </form>
                </section>
                <section className="border border-ink/10 bg-night p-7 text-ivory">
                    <Kicker dark>Zero Trust access</Kicker>
                    <p className="mt-5 font-serif text-2xl font-medium leading-snug">Your workspace is isolated by employer identity.</p>
                    <p className="mt-4 text-sm leading-relaxed text-ivory/60">
                        Employer accounts can only access their own company profile, jobs, applicants, documents, interviews and notifications. Administrative functions remain restricted to Afrinexa staff.
                    </p>
                </section>
            </div>
        </EmployerLayout>
    );
}
